import { useCallback } from 'react';
import { getDataLayer } from '../../utils';

const emptyFunction = () => {};
const useGTM = () => {
  const dataLayer = getDataLayer();
  const pushData = useCallback(data => dataLayer.push(data), [dataLayer]);
  const pushToGTM = dataLayer ? pushData : emptyFunction;

  return [pushToGTM];
};

export default useGTM;
